let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1FCZ9")).then(() => parcelRequire('c4Fu9'));